import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Typography } from "@mui/material";
import { CheckCircleIcon } from "../../../../../assets/icons/CheckCircleIcon";

const ExamOrderCard = ({ id, label, isDragMode }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const dragStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: isDragMode ? "grabbing" : "grab",
  };

  return (
    <Box
      id={id}
      key={id}
      display="flex"
      justifyContent="center"
      p="8px"
      borderRadius="4px"
      minWidth={{ xs: "200px", sm: "250px" }}
      boxShadow="-20px 0px 25px rgba(0, 0, 0, 0.05)"
      border="1px solid #202338"
      backgroundColor="#202338"
      color="#FFF"
      style={{ ...dragStyle }}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      <CheckCircleIcon color="#22BE39" />
      <Typography fontWeight={600} sx={{ ml: "8px" }}>
        {label}
      </Typography>
    </Box>
  );
};

export default ExamOrderCard;
